import * as React from "react";
import { Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <footer className="footer">
      <Row className="align-items-center justify-content-xl-between">
        <Col xl="12">
          <div className="copyright text-center text-xl-center text-muted">
            © {new Date().getFullYear()} Intivine, Inc.
          </div>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
